import { KIND } from './';
import { borderColor, borderRadius, borderWidth, paddingSize } from '../../Utilities/utils/Theming';

export const notificationColor = (kind: KIND[keyof KIND] | undefined, $theme: any) => {
	if (kind === 'positive') {
		return {
			backgroundColor: $theme.notification.notificationPositiveBackground,
			...borderColor($theme.notification.borderColorPositive),
		};
	} else if (kind === 'warning') {
		return {
			backgroundColor: $theme.notification.notificationWarningBackground,
			...borderColor($theme.notification.borderColorWarning),
		};
	} else if (kind === 'negative') {
		return {
			backgroundColor: $theme.notification.notificationNegativeBackground,
			...borderColor($theme.notification.borderColorNegative),
		};
	} else if (kind === 'info') {
		return {
			backgroundColor: $theme.notification.notificationInfoBackground,
			...borderColor($theme.notification.borderColorInfo),
		};
	} else {
		return {
			backgroundColor: $theme.notification.notificationNeutralBackground,
			...borderColor($theme.notification.borderColorNeutral),
		};
	}
};

export const notificationBaseStyle = (kind: KIND[keyof KIND] | undefined, shadow: boolean | undefined, $theme: any) => {
	return {
		width: 'fit-content',
		maxWidth: '369px',
		fontFamily: 'var(--epods--font-base-semibold)',
		fontSize: 'var(--epods--font-size-p)',
		lineHeight: 'var(--epods--feedback-static-text-line-height)',
		zIndex: 'var(--epods--zindex-notification)' as any,
		...borderWidth('var(--epods--border-width)'),
		borderStyle: 'solid',
		...borderRadius('var(--epods--border-radius)'),

		boxShadow: shadow ? 'var(--epods--box-shadow-forth-bottom)' : 'none',
		...paddingSize(
			$theme.notification.notificationBodyPaddingTopBottom,
			$theme.notification.notificationBodyPaddingRight,
			$theme.notification.notificationBodyPaddingTopBottom,
			$theme.notification.notificationBodyPaddingLeft,
		),
		...notificationColor(kind, $theme),

		'@media screen and (min-width: $epo-laptop-xl2)': {
			maxWidth: '375px',
		},
	};
};

export const notificationTextStyle = {
	color: 'var(--epods--color-text-primary)',
};

export const notificationActionStyle = {
	marginTop: 'var(--epods--notification-action-margin-top)',
	display: 'flex',
	alignItems: 'center',
};

export const notificationExternalLinkStyle = {
	marginRight: 'var(--epods--notification-action-margin-between) !important',
};

export const notificationCloseStyle = {
	color: 'var(--epods--color-text-primary)',
	fill: 'var(--epods--color-text-primary)',
	width: '24px',
	height: '24px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	marginLeft: 'var(--epods--space-inset-xs2)',
};
